module.exports = __webpack_public_path__ + "media/media/about/remote_update-719e76bcf99afa7d2af9c2066a1d13d7.png";